import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png";

const DISMembership = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">DIS Membership</h1>
          <p className="subtitle">
            Library and Information Services for standards and standards-related information.
          </p>
        </div>
      </section>

      {/* === Content Section === */}
      <section className="content-section">
        <div className="content-card">

          <p className="subtitle left-text">
            The Malawi Bureau of Standards (MBS) operates a Library Membership Scheme 
            (MBS Documentation and Information Services Scheme – MBS-DIS Scheme), which enables access to standards 
            and standards-related information available in the MBS Library for companies, organizations, educational institutions, 
            parastatal bodies, government departments, and individuals.
          </p>

          <p className="subtitle left-text">
            The MBS-DIS Scheme provides to institutions and individuals Malawi standards, international standards, 
            foreign national standards, industrial books, journals, magazines, brochures, DVDs, and Catalogues of 
            National and International Standards, among others.
          </p>

          <div className="benefits-box">
            <p className="benefits-title left-text">Other benefits of the scheme:</p>
            <ul className="benefits-list">
              <li>Access to the information resources highlighted above for free.</li>
              <li>20% reduction in the purchase of Malawi Standards.</li>
              <li>Receipt of periodicals and other relevant documents and information from the MBS, including: Catalogue of Malawi Standards, MBS Annual Report, Information leaflets, etc.</li>
            </ul>
          </div>

          <p className="subtitle left-text">
            The MBS continuously receives the latest information from various sectors of the economy catering for different industries, 
            from International Organization for Standardization (ISO), International Electrotechnical Commission (IEC), 
            Codex Alimentarius Commission (CAC), Food and Agriculture Organization (FAO), World Trade Organization (WTO), 
            and National Standards from numerous countries worldwide.
          </p>

          <div className="membership-category-box bw-table">
            <p className="benefits-title left-text">Current Annual subscription rates for the scheme:</p>
            <table className="membership-table bw">
              <thead>
                <tr>
                  <th>Category of Membership</th>
                  <th>Annual Subscription</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Institutional Membership</td>
                  <td>MK 5,000.00</td>
                </tr>
                <tr>
                  <td>Individual Membership</td>
                  <td>MK 2,000.00</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* === Contact Section (Aligned & Centered) === */}
          <div className="centered-section contact-lines">
            <p>Director General</p>
            <p>Malawi Bureau of Standards</p>
            <p>P O Box 946</p>
            <p>BLANTYRE</p>

            <br />

            <p>Tel: 01 870 488</p>
            <p>Fax: 01 870 756</p>

            <br />

            <p>Email: mbs@mbsmw.org</p>
            <p>Website: www.mbsmw.org</p>

            <br />

            <p className="download-link">
              📌 <a href="/files/MBS-DIS-SCHEME-APPLICATION-FORM.pdf" download>
                Download DIS Membership Form
              </a>
            </p>
          </div>

        </div>
      </section>

      {/* === Inline Styles === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }

        .page-title { font-size: 2.8rem; font-weight: bold; margin-bottom: 10px; }
        .subtitle { font-size: 1rem; margin-bottom: 15px; line-height: 1.8; }

        .content-section { padding: 50px 20px; display: flex; justify-content: center; }
        .content-card { max-width: 1600px; width: 100%; text-align: left; padding: 40px 60px; background: #fff; border-radius: 15px; box-shadow: 0 6px 25px rgba(0,0,0,0.1); }

        .left-text { text-align: left; }
        .centered-section { text-align: center; }
        .contact-lines p { margin: 4px 0; line-height: 1.4; }

        .benefits-box {
          background-color: #fff6f0;
          border: 1px solid #ff6600;
          border-radius: 12px;
          padding: 25px 30px;
          margin: 25px 0;
        }

        .benefits-title { font-weight: bold; font-size: 1.1rem; margin-bottom: 12px; }
        .benefits-list { padding-left: 20px; list-style-type: disc; }
        .benefits-list li { margin-bottom: 10px; }

        .membership-category-box.bw-table { border: 1px solid #333; border-radius: 12px; padding: 20px; margin: 25px 0; }
        .membership-table.bw { width: 100%; border-collapse: collapse; margin-top: 10px; }
        .membership-table.bw th, .membership-table.bw td { border: 1px solid #333; padding: 10px; font-size: 1rem; }
        .membership-table.bw th { background-color: #f5f5f5; }

        .download-link a { color: #ff6600; font-weight: bold; text-decoration: none; }
        .download-link a:hover { text-decoration: underline; }

        @media screen and (max-width: 1024px) {
          .content-card { max-width: 95%; padding: 30px 30px; }
        }

        @media screen and (max-width: 768px) {
          .about-header { height: 35vh; }
          .overlay { width: 95%; padding: 25px; }
          .page-title { font-size: 2rem; }
          .content-section { padding: 25px 15px; }
          .content-card { padding: 25px 20px; }
        }
      `}</style>
    </div>
  );
};

export default DISMembership;
